module.exports = __webpack_public_path__ + "img/img-125.ebd21651.png";